import { HeaderProps } from '../Header/types';
import './styles.scss';
import { formattingNumber } from 'utils';

export const ProductMadnessHeader: React.FC<HeaderProps> = ({
  balanceQuantityFormat,
  balances,
  playerName,
  profilePicUrl = 'https://media.appcharge.com/defaults/old-profile.png',
  openLogoutModal,
  translations = { yourBalance: 'YOUR BALANCE' },
}) => (
  <div className={'jackpot-slots-header'}>
    <div className={'jackpot-slots-header__balance'}>
      {balances && balances.length > 0 && (
        <>
          <img
            className="jackpot-slots-header__balance__image"
            alt="balance"
            src={balances[0].image}
          />
          <div className={'jackpot-slots-header__balance__text'}>
            <span className={'jackpot-slots-header__balance__text__prefix'}>
              {translations.yourBalance}
            </span>
            <span className={'jackpot-slots-header__balance__text__balance'}>
              {balanceQuantityFormat
                ? formattingNumber({
                    number: balances[0].amount || '',
                    config: balanceQuantityFormat,
                  })
                : balances[0].amount}
            </span>
          </div>
        </>
      )}
    </div>
    <div className={'jackpot-slots-header__profile'} onClick={openLogoutModal}>
      {profilePicUrl && (
        <div className={'jackpot-slots-header__profile__image-border'}>
          <img
            alt={'profile-image'}
            src={profilePicUrl}
            className={'jackpot-slots-header__profile__image'}
          />
        </div>
      )}
      <span className={'jackpot-slots-header__profile__name'}>
        {playerName}
      </span>
    </div>
  </div>
);
